import { Dispatch } from 'redux';
import { setIncident } from './incidentReducer';
import { ApiAssistanceIncidentType } from '../../../api';

export const saveIncident =
  (incident: ApiAssistanceIncidentType) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(setIncident(incident));
  };
